import { render, staticRenderFns } from "./SerienButton.vue?vue&type=template&id=661536c4&"
import script from "./SerienButton.vue?vue&type=script&lang=js&"
export * from "./SerienButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/Plenty Update/pp-weberbuero/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661536c4')) {
      api.createRecord('661536c4', component.options)
    } else {
      api.reload('661536c4', component.options)
    }
    module.hot.accept("./SerienButton.vue?vue&type=template&id=661536c4&", function () {
      api.rerender('661536c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/SerienButton.vue"
export default component.exports